export class StatusModel {
    id: string;
    name: string;
    internal: string;
    displayed_name: string;
    displayed_name_ro: string;
    id_courier: string;
}
